<template>
  <div class="kyc-dropdown">
    <div
      class="dropdown-card"
      :class="{
        'is-clickable': editStatus,
        'is-open': openDropdown
      }"
    >
      <div class="dropdown-header" @click="showDropdown">
        <div class="header-icon">
          <template v-if="$route.name === 'Kyc' || $route.name === 'IdentityVerification'">
            <svg v-if="(status && edit === 'null') || (status && edit === 'Approved')" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#10B981" stroke-width="1.5"/>
              <path d="M6.66667 10L8.88889 12.2222L13.3333 7.77778" stroke="#10B981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="!status" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#94A3B8" stroke-width="1.5"/>
            </svg>
            <svg v-else-if="status && edit === 'Pending'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#F59E0B" stroke-width="1.5"/>
              <path d="M10 6.66667V10" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="10" cy="13.3333" r="0.833333" fill="#F59E0B"/>
            </svg>
            <svg v-else-if="status && edit === 'Rejected'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#EF4444" stroke-width="1.5"/>
              <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </template>
          <template v-else>
            <svg v-if="title === 'Asset Information'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 1.66667L12.575 6.88334L18.3333 7.725L14.1667 11.7833L15.15 17.5167L10 14.8083L4.85 17.5167L5.83333 11.7833L1.66667 7.725L7.425 6.88334L10 1.66667Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="title === 'Investment Memo'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6667 1.66667H5C4.55797 1.66667 4.13405 1.84227 3.82149 2.15483C3.50893 2.46739 3.33333 2.89131 3.33333 3.33334V16.6667C3.33333 17.1087 3.50893 17.5326 3.82149 17.8452C4.13405 18.1577 4.55797 18.3333 5 18.3333H15C15.442 18.3333 15.866 18.1577 16.1785 17.8452C16.4911 17.5326 16.6667 17.1087 16.6667 16.6667V6.66667L11.6667 1.66667Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.6667 1.66667V6.66667H16.6667" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3333 10.8333H6.66667" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3333 14.1667H6.66667" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="title === 'Location'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 8.33334C17.5 14.1667 10 19.1667 10 19.1667C10 19.1667 2.5 14.1667 2.5 8.33334C2.5 6.34422 3.29018 4.43656 4.6967 3.03004C6.10322 1.62352 8.01088 0.833336 10 0.833336C11.9891 0.833336 13.8968 1.62352 15.3033 3.03004C16.7098 4.43656 17.5 6.34422 17.5 8.33334Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 10.8333C11.3807 10.8333 12.5 9.71406 12.5 8.33334C12.5 6.95263 11.3807 5.83334 10 5.83334C8.61929 5.83334 7.5 6.95263 7.5 8.33334C7.5 9.71406 8.61929 10.8333 10 10.8333Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="title === 'Founders Information'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80964 13.4763C1.18452 14.1014 0.833336 14.9493 0.833336 15.8333V17.5" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.5 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.5 2.5C5.65905 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65905 9.16667 7.5 9.16667Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.1667 17.5V15.8333C19.166 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.3333 2.60834C14.0503 2.79192 14.686 3.20892 15.1397 3.79359C15.5935 4.37827 15.8398 5.09736 15.8398 5.8375C15.8398 6.57765 15.5935 7.29674 15.1397 7.88141C14.686 8.46609 14.0503 8.88309 13.3333 9.06667" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else-if="title === 'Socials'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.66667 10H18.3333" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 1.66667C12.0844 3.94863 13.269 6.91003 13.3333 10C13.269 13.09 12.0844 16.0514 10 18.3333C7.91562 16.0514 6.73106 13.09 6.66667 10C6.73106 6.91003 7.91562 3.94863 10 1.66667Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="#4D84FF" stroke-width="1.5"/>
            </svg>
          </template>
        </div>
        <div class="header-content">
          <h3 class="dropdown-title">{{ title }}</h3>
          <p class="dropdown-subtitle">{{ subTitle }}</p>
        </div>
        <div v-if="editStatus" class="chevron-icon" :class="{ 'is-rotated': openDropdown }">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <transition
        name="dropdown"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
      >
        <div v-show="openDropdown" class="dropdown-content">
          <slot name="content"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { abbreviate } from "@/utils/helpers.js";

export default {
  name: "KycDropdown",

  props: {
    title: { type: String, default: () => "", required: true },
    subTitle: { type: String, default: () => "" },
    status: { type: Boolean, default: () => false, required: true },
    edit: { type: String, default: () => "", required: true },
  },

  data() {
    return {
      openDropdown: false,
      statusElement: [],
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
    }),

    editStatus() {
      return this.edit === "" || this.edit === "Rejected";
    },
  },

  inject: ["activeDropdown"],

  methods: {
    abbreviate,

    showDropdown() {
      if (this.editStatus) {
        this.openDropdown = !this.openDropdown;
        if (this.openDropdown) this.$emit("active-dropdown", this.title);
      }
    },

    enter(element) {
      element.style.height = "auto";
      let height = getComputedStyle(element).height;
      element.style.height = 0;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = 0;
      });
    },
  },

  watch: {
    orgDetails(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        setTimeout(() => {}, 500);
      }
    },
    activeDropdown(val) {
      if (this.title === val) {
        this.openDropdown = true;
      } else {
        this.openDropdown = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.kyc-dropdown {
  margin-bottom: 16px;
}

.dropdown-card {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;

  &.is-clickable {
    cursor: pointer;
  }

  &.is-open {
    border-color: #CBD5E1;
  }
}

.dropdown-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  gap: 16px;
}

.header-icon {
  width: 40px;
  height: 40px;
  background: #EEF2FF;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.dropdown-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 4px 0;
}

.dropdown-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #64748B;
  margin: 0;
}

.chevron-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748B;
  transition: transform 0.2s ease;
  flex-shrink: 0;

  &.is-rotated {
    transform: rotate(180deg);
  }
}

.dropdown-content {
  border-top: 1px solid #E2E8F0;
  padding: 24px;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: height 0.3s ease-in-out;
  overflow: hidden;
}
</style>
